var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"TicketRequests-View"},[_c('SpaceDescription',[_c('Headline',{attrs:{"size":1}},[_vm._v("Ticket Requests")])],1),_c('TicketRequestListTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }